var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance-app"},[_c('HistoryTimeline',{attrs:{"maintenanceId":this.$route.params.uid}}),_c('ImageViewDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }